import { useTracking } from "render/hooks/useTracking";
import { PopUpLayout } from "render/ui/layout/PopUpLayout/PopUpLayout";
import { Typography } from "render/ui/presentation/Typography";
import { ActionButton } from "render/ui/trigger/ActionButton";
import { Trans } from "../ContactUs/trans";
import styles from "./styles.module.sass";
import { contactFormEvent } from "./tracking";

interface ContactUsPopupProps {
  onClose: () => void;
}

export function ContactUsPopup({ onClose }: ContactUsPopupProps) {
  const { trackEvent } = useTracking();

  return (
    <PopUpLayout
      onClose={onClose}
      header={
        <Typography style={{ marginBottom: "20px" }} variant="title-medium">
          <Trans.ContactUs.Title />
        </Typography>
      }
    >
      <div className={styles.body}>
        <div className={styles.content}>
          <div className={styles.info}>
            <Typography style={{ color: "#263032" }} variant="paragraph-sub">
              <Trans.ContactUs.Text />{" "}
            </Typography>
            <Typography
              style={{ color: "#263032", marginTop: "16px" }}
              variant="paragraph-sub"
            >
              <Trans.ContactUs.ChestPain />
            </Typography>
          </div>

          <ActionButton
            style={{ marginTop: "24px" }}
            onClick={() => {
              trackEvent(contactFormEvent.formSubmitButtonClick());
              trackEvent(contactFormEvent.formSubmit());
              window.location.href = "sms:+46726009690";
            }}
          >
            <div className={styles.buttonText}>
              <div className={styles.text}>
                <Trans.ContactUs.TextUs />
              </div>
              <div className={styles.phone}>+46 72 600 96 90</div>
            </div>
          </ActionButton>
        </div>
      </div>
    </PopUpLayout>
  );
}
